import { ChronoUnit, LocalDate } from '@js-joda/core';

import { getIssuedFromDefaultValue, isIssuedFromInThePast } from './issuedFrom';

const MONTH_IN_DAYS = 30;
const YEAR_IN_DAYS = 365;

export const isIssuedForMoreThanMonth = (startDate: LocalDate, endDate: LocalDate): boolean => {
   return ChronoUnit.DAYS.between(startDate, endDate) > MONTH_IN_DAYS;
};

export const changeIssuedToDateFromPastToTodayOnly = (issuedTo: LocalDate): LocalDate => {
   if (isIssuedFromInThePast(issuedTo)) {
      return getIssuedFromDefaultValue();
   }

   return issuedTo;
};

export const calculateNewIssuedToLocalDate = (
   issuedFrom: LocalDate | null,
   issuedForYear: boolean
): LocalDate | null => {
   if (!issuedFrom) {
      return null;
   }

   const daysToProlong = issuedForYear ? YEAR_IN_DAYS : MONTH_IN_DAYS;
   return issuedFrom.plusDays(daysToProlong);
};
